import React from 'react'
import PropTypes from 'prop-types'

import TableSplitButton from '~/components/TableSplitButton'
import useDeleteConfirm from '~/components/TableSplitButton/useDeleteConfirm'

function BulkActionButton ({ onCategoriesDelete, loading }) {
  const { handleClick } = useDeleteConfirm()

  const options = [
    {
      label: 'Delete',
      'data-cy': 'deleteMenu',
      onMenuClick: () => handleClick(onCategoriesDelete)
    },
  ]

  return (
    <TableSplitButton
      options={options}
      name="category"
      loading={loading}
    />
  )
}

BulkActionButton.propTypes = {
  onCategoriesDelete: PropTypes.func.isRequired,
  loading: PropTypes.bool
}

export default BulkActionButton
